// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-content[data-v-3b9b69e5]{background-color:#fff;border:1px solid #ededed;border-radius:8px;position:relative}.modal-content-close[data-v-3b9b69e5]{position:absolute;cursor:pointer;right:16px;top:4px;font-size:28px}.modal-content-close[data-v-3b9b69e5]:hover{opacity:.7}", ""]);
// Exports
module.exports = exports;
